import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 5.5em);

  .content-oc {
    width: 100%;
  }
`;

export const ThisCol = styled.div`
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 15em;
  height: fit-content;
  position: relative;
  overflow-x: hidden;
  // box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color13};

  ${props => {
    if (props?.index == 0) {
      return `margin-left: 0em;`;
    } else {
      return `margin-left: 1em;`;
    }
  }}

  .list-header {
    padding: 0.8em;
    margin-left: 0.8em;
    margin-top: 0.4em;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;

    .titulo {
      font-size: 0.78em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
      font-weight: 800;
      color: ${Colors.Color4};
    }
  }

  .list-body {
    padding: 0.3em 0.6em 0.6em 0.6em;
    background: ${Colors.Color13};
    width: 100%;
    min-height: 5em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 25em;
    overflow: auto;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 0.7em;
  padding: 0.8em;
  border-radius: 0.6875em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  position: relative;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color2 : Colors.Color2};
  box-shadow: none !important;

  .card-header {
    width: 100%;

    .card-header-top {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .codigo {
        font-size: 0.5625em;
        color: ${Colors.Color4};
        font-weight: 700;
      }

      .data {
        color: ${Colors.Color20};
        font-size: 0.5625em;
        font-weight: 700;
      }

      .card-header-priori {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;

        .titulo {
          color: ${Colors.Color4};
          font-size: 0.65em;
          font-weight: 700;
        }
      }
    }

    .titulo {
      color: ${Colors.Color4};
      font-size: 0.65em;
      font-weight: 700;
    }

    .cliente {
      color: ${Colors.Color20};
      font-size: 0.6em;
      font-weight: 600;
    }
  }

  .card-footer {
    margin-top: 1em;

    .responsavel {
      color: ${Colors.Color20};
      font-size: 0.65em;
      font-weight: 600;
    }
  }
`;

export const ThisCardColor = styled.span`
  background: #${props => (props?.cor ? props?.cor : Colors.Color4)};
  width: 1.905em;
  height: 0.375em;
  border-radius: 1em;
  //margin-right: 0.4em;
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;

  .display-oc {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: max-content;
  }
`;